import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmptyObject, objectToArray, resourceIconMap } from 'utils';
import { form } from 'types';
import Cards from './cards-layout';
import CardBasic from './card-basic';
import TableView from './table-view';
import Icon from './icon';
import Form from './form';
import Confirm from './confirm-dialog';
import Dialog from './dialog';
import PropertiesDialog from './properties-dialog';

export default ({
  sectionTitle = '',
  createForm,
  createActionType,
  onCreateClick,
  isAddButton = true,
  editForm,
  filterRender,
  items = [],
  setItemTitle,
  setItemDetails,
  itemIcon = '',
  itemIconColor = 'var(--color-base)',
  setItemIconColor,
  itemIconAlign = 'center', // top, center, bottom
  itemImage = '',
  actionButton, // { icon, color, title, onClick, isConfirmModel, confirmMessage }
  actionButtons: actionButtonsInput, // [{ icon, color, title, onClick, isConfirmModel, confirmMessage }]
  actionForm, // icon, title, formProps, isClose = false, color
  setItemImage,
  setItemIconText,
  itemOnDelete,
  itemOnEdit,
  setItemEditProps,
  itemOnClick,
  setItemKey,
  itemProps = {},
  setTableRows,
  tableColumns,
  isEmptyState = true,
  style = {},
  className = '',
  isDeletePassword,
  isItemDetailsModel = false,
  setDetailsModelTable,
  setItemLoading,
  refresh,
  showAddForm,
  onCloseAddForm,
  scrollIntoForm,
  inlineEdit = false,
  customTopbarForm,
}) => {
  if (!Array.isArray(items)) items = [];
  const { listViewType = '' } = useSelector((e) => e);
  const [deleteItem, setDeleteItem] = useState({});
  const [editItem, setEditItem] = useState({});
  const [actionFormItem, setActionFormItem] = useState(false);
  const [viewItem, setViewItem] = useState({});
  const [actionButtonConfirmation, setActionButtonConfirmation] = useState(null);

  itemIcon = resourceIconMap(itemIcon) || itemIcon;

  const confirmDeleteHandler = (isDelete) => {
    if (isDelete) {
      itemOnDelete(deleteItem);
    }
    setDeleteItem({});
  };

  const editSubmitHandler = (values) => {
    itemOnEdit(values);
    setEditItem({});
  };

  const confirmActionButtonHandler = (isConfirmed) => {
    if (isConfirmed && actionButton.onClick) {
      actionButton.onClick(actionButtonConfirmation);
    }
    setActionButtonConfirmation(null);
  };

  const renderFormDialog = () => {
    const localActionForm = actionForm.formProps(actionFormItem);
    return (
      <Dialog
        show
        title={actionForm?.title}
        titleClassName="-m-b-12- -p-b-1"
        content={(
          <Form
            {...form({
              ...localActionForm,
              onSubmit: (e) => {
                setActionFormItem({});
                if (localActionForm.onSubmit) localActionForm.onSubmit(e, actionFormItem);
              },
              onCancel: () => setActionFormItem({}),
            })}
          />
        )}
        isCloseButton={false}
        closeHandler={() => setActionFormItem({})}
        style={{ minWidth: 300 }}
      />
    );
  };

  let renderElement = React.isValidElement(createForm) ? createForm : <Form isCancel={false} {...createForm} />;
  if (!isEmptyObject(editItem) && inlineEdit) {
    renderElement = React.cloneElement(editForm, { editItem, onSubmit: editSubmitHandler });
  }

  return (
    <Cards
      title={sectionTitle}
      addRender={renderElement}
      isAdd={isAddButton && (!!createForm || !!onCreateClick)}
      addAction={createActionType}
      filterRender={filterRender}
      isFilter={!!filterRender}
      isToggleButton={items.length}
      isEmpty={!items.length && isEmptyState}
      style={style}
      onAdd={onCreateClick}
      className={className}
      refresh={refresh}
      showAddForm={!isEmptyObject(editItem) || showAddForm}
      onCloseAddForm={() => {
        if (onCloseAddForm) onCloseAddForm();
        if (!isEmptyObject(editItem)) setEditItem({});
      }}
      scrollIntoForm={scrollIntoForm}
      customTopbarForm={customTopbarForm}
    >
      {listViewType === 'table' ? (
        <TableView
          name="servers"
          rows={items.map((e, index) => {
            const actionButtons = [];
            if (itemOnDelete) actionButtons.push(<Icon name="trash" style={{ color: 'var(--color-danger)' }} onClick={() => setDeleteItem(e)} />);
            if (itemOnEdit) actionButtons.push(<Icon name="edit" style={{ color: 'var(--color-success)' }} onClick={() => setEditItem(e)} />);

            if (actionButton && (!actionButton.condition || actionButton.condition(e))) {
              actionButtons.push(
                <Icon
                  name={actionButton?.icon}
                  tooltip={actionButton?.tooltip}
                  style={{ color: actionButton?.color || 'var(--color-base)' }}
                  title={actionButton?.title}
                  onClick={() => (actionButton?.isConfirmModel ? setActionButtonConfirmation(e) : actionButton?.onClick?.(e))}
                />,
              );
            }

            if (actionButtonsInput) {
              actionButtons.push(
                ...actionButtonsInput.map((button) => (
                  <Icon
                    name={button?.icon}
                    tooltip={button?.tooltip}
                    style={{ color: button?.color || 'var(--color-base)' }}
                    title={button?.title}
                    onClick={() => (button?.isConfirmModel ? setActionButtonConfirmation(e) : button?.onClick?.(e))}
                  />
                )),
              );
            }

            if (actionForm && (!actionForm.condition || actionForm.condition(e))) {
              actionButtons.push(
                <Icon
                  name={actionForm?.icon}
                  style={{ color: actionForm?.color || 'var(--color-base)' }}
                  title={actionForm?.title}
                  onClick={() => setActionFormItem(e)}
                />,
              );
            }

            return (
              setTableRows
                ? [...setTableRows(e), ...actionButtons]
                : [
                  itemIcon ? <Icon name={itemIcon} /> : itemImage
                    ? <img src={itemImage} alt="" /> : setItemImage
                      ? <img src={setItemImage(e)} alt="" /> : '',
                  setItemTitle ? itemOnClick ? { link: e, value: setItemTitle(e, index) } : setItemTitle(e, index) : '',
                  setItemDetails ? setItemDetails(e) : '',
                  ...actionButtons,
                ]);
          })}
          columns={tableColumns || (setItemDetails ? ['', 'Name', 'Details'] : ['', 'Name'])}
          onCellClick={(e) => !!itemOnClick && itemOnClick(e)}
        />
      ) : (
        items.map((e, i) => {
          const actionButtons = {};
          if (itemOnDelete) actionButtons.delete = () => setDeleteItem(e);
          if (itemOnEdit) actionButtons.edit = () => setEditItem(e);
          if (isItemDetailsModel) actionButton = { icon: 'search', title: 'View Item', onClick: () => setViewItem(e) };
          if ((itemOnDelete || itemOnEdit) && itemOnClick) {
            actionButtons.arrow = () => itemOnClick(e);
          }

          const buttons = [];

          if (actionButton && (!actionButton.condition || actionButton.condition(e))) {
            buttons.push({
              color: actionButton?.color || 'var(--color-base)',
              name: actionButton?.icon,
              icon: actionButton?.icon,
              title: actionButton?.title,
              tooltip: actionButton?.tooltip,
              onClick: (clickEvent) => (actionButton?.isConfirmModel ? setActionButtonConfirmation(e) : actionButton?.onClick?.(clickEvent, e)),
            });
          }

          if (actionButtonsInput) {
            actionButtonsInput.forEach((button) => {
              buttons.push({
                color: button?.color || 'var(--color-base)',
                name: button?.icon,
                icon: button?.icon,
                title: button?.title,
                tooltip: button?.tooltip,
                onClick: (clickEvent) => (button?.isConfirmModel ? setActionButtonConfirmation(e) : button?.onClick?.(clickEvent, e)),
              });
            });
          }

          if (actionForm && (!actionForm.condition || actionForm.condition(e))) {
            buttons.push({
              color: actionForm?.color || 'var(--color-base)',
              name: actionForm?.icon,
              icon: actionForm?.icon,
              title: actionForm?.title,
              onClick: () => setActionFormItem(e),
            });
          }

          return (
            <CardBasic
              key={setItemKey ? setItemKey(e) : i}
              title={setItemTitle ? setItemTitle(e, i) : ''}
              details={setItemDetails ? setItemDetails(e) : ''}
              icon={itemIcon}
              iconFill={setItemIconColor ? setItemIconColor(e) : itemIconColor}
              image={setItemImage ? setItemImage(e) : itemImage}
              actionButtons={actionButtons}
              onClick={() => (!!itemOnClick && !(itemOnDelete || itemOnEdit)) && itemOnClick(e)}
              isArrow={!!itemOnClick && !(itemOnDelete || itemOnEdit)}
              isLoader={setItemLoading && setItemLoading(e)}
              iconText={setItemIconText && setItemIconText(e)}
              iconAlign={itemIconAlign}
              buttons={buttons}
              {...itemProps}
            />
          );
        }))}

      {!!actionButtonConfirmation && (
        <Confirm
          isPassword={isDeletePassword}
          show
          onClose={confirmActionButtonHandler}
          message={actionButton?.confirmMessage}
        />
      )}

      {!isEmptyObject(deleteItem) && (
        <Confirm
          isPassword={isDeletePassword}
          show
          onClose={confirmDeleteHandler}
        />
      )}


      {!isEmptyObject(editItem) && !inlineEdit && (
        <Dialog
          show
          content={
            <Form isCancel={false} {...createForm} onSubmit={editSubmitHandler} onProps={setItemEditProps ? setItemEditProps(editItem) : editItem} />
          }
          isCloseButton
          closeHandler={() => setEditItem({})}
          style={{ minWidth: 300 }}
        />
      )}

      {!isEmptyObject(actionFormItem) && renderFormDialog()}

      {!isEmptyObject(viewItem) && (
        <PropertiesDialog
          show
          properties={setDetailsModelTable ? setDetailsModelTable(viewItem) : objectToArray(viewItem)}
          onClose={() => setViewItem({})}
          title={setItemTitle ? setItemTitle(viewItem) : ''}
        />
      )}
    </Cards>
  );
};
